module.exports = __webpack_public_path__ + "static/media/pecas.9265adf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/Players/pecas.jpg
// module id = 309
// module chunks = 0